/// <amd-module name="Test/TestPlansHubRefresh/BreadcrumbService/TestPlansHubRefreshBreadcrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { Services, VssService } from "VSS/Platform/Context";
import { FastPageSwitch } from "VSS/Platform/FPS";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

export class TestPlansHubRefreshBreadcrumbService extends VssService implements IBreadcrumbItemService {
    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public clearTestPlanNameBreadcrumb() {
        this.items.pop();
    }

    public addBreadCrumb(key: string, text: string, url?: string, priority?: number) {

        this.items.push({
            key: key,
            text: text,
            priority: priority,
            onClick: url ? () => {
                FastPageSwitch(this.pageContext, url, true);
            } : undefined
        });
    }
}

Services.add("testplans-hub-refresh-breadcrumb-service", { serviceFactory: TestPlansHubRefreshBreadcrumbService });
